"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Druid_1 = require("../../Druid");
const EventHandler_1 = require("../../Framework/EventHandler");
const Bind_1 = require("../../Utility/Decorator/Bind");
const Debounce_1 = require("../../Utility/Decorator/Debounce");
const DocumentEventListener_1 = require("../../Components/Event/DocumentEventListener");
const Scroll_1 = require("../../Components/Framework/Scroll");
class Dropdown {
    constructor(options) {
        this.events = new EventHandler_1.default();
        this.showing = false;
        this.contextHeight = -1;
        this.dropdownHeight = -1;
        this.container = options.container;
        this.context = options.context;
        this.dropdown = options.dropdown;
        this.alignment = options.alignment;
        this.offset = options.offset;
        this.minWidth = options.minWidth;
        // add resize observer for context element. Condition required for browser support
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        // istanbul ignore next
        if (window.ResizeObserver) {
            // we need the animation frame to avoid a resize observer error. fixes bug #127753
            // @see https://stackoverflow.com/a/76714495
            const observer = new ResizeObserver((entries) => {
                window.requestAnimationFrame(() => {
                    if (!Array.isArray(entries) || !entries.length) {
                        return;
                    }
                    this.reposition();
                });
            });
            observer.observe(this.context);
            observer.observe(this.dropdown);
        }
        this.documentListener = new DocumentEventListener_1.default('click', [options.context, options.dropdown], this.hide);
        if (Druid_1.default.configuration().scrollLock) {
            Scroll_1.default.setScrollLock(this.dropdown);
        }
    }
    setContent(content) {
        this.dropdown.innerHTML = content;
        return this;
    }
    scrollToTop() {
        this.dropdown.scrollTo(0, 0);
        return this;
    }
    setMinimumWidth(width) {
        this.dropdown.style.minWidth = width + 'px';
        return this;
    }
    isEmpty() {
        return this.dropdown.innerHTML.trim() === '';
    }
    /**
     * Set alignment of the dropdown.
     *
     * @see setRelativeTo
     */
    setAlignment(alignment) {
        this.alignment = alignment;
        return this;
    }
    show() {
        this.showing = true;
        this.documentListener.enable();
        this.setPosition();
        return this;
    }
    isShowing() {
        return this.showing;
    }
    hide() {
        if (this.showing === false) {
            return this;
        }
        this.showing = false;
        // hide the element outside view, but don't set display to none
        this.dropdown.style.top = '-10000px';
        this.dropdown.style.left = '-10000px';
        this.dropdown.style.visibility = 'hidden';
        this.documentListener.disable();
        this.events.trigger('hide');
        return this;
    }
    onHide(handler) {
        this.events.on('hide', handler);
    }
    toggle() {
        if (this.showing) {
            this.hide();
        }
        else {
            this.show();
        }
        return this;
    }
    /**
     * Attach the dropdown element to the given parent
     */
    attachTo(parentElement) {
        parentElement.appendChild(this.dropdown);
    }
    /**
     * Remove dropdown from the dom
     */
    detach() {
        this.dropdown.remove();
    }
    getHTMLElement() {
        return this.dropdown;
    }
    reposition() {
        if (this.showing === false) {
            return;
        }
        // if the height of `context` or `dropdown` didn't change since last positioning, just return
        if (this.context.getHeight('outer') === this.contextHeight && this.dropdown.getHeight('outer') === this.dropdownHeight) {
            return;
        }
        // reposition dropdown but stick to current alignment. Restore scroll position after
        const scrollTop = this.dropdown.scrollTop;
        this.setPosition(this.currentAlignment);
        this.dropdown.scrollTop = scrollTop;
    }
    /**
     * Determine the best position of the dropdown
     *
     * @param alignment Optionally set preferred alignment over the configured dropdown alignment
     */
    setPosition(alignment) {
        var _a;
        this.dropdown.style.visibility = '';
        if (this.minWidth !== undefined) {
            this.dropdown.style.minWidth = this.minWidth + 'px';
        }
        this.currentAlignment = this.dropdown.setRelativeTo(this.context, 
        // istanbul ignore next - unable to hit local 'alignment' variable
        (_a = alignment !== null && alignment !== void 0 ? alignment : this.alignment) !== null && _a !== void 0 ? _a : 'Br/Bl/Tr/Tl', this.container, {
            offset: this.offset,
            autoHeight: true,
            detectViewport: true
        });
        this.contextHeight = this.context.getHeight('outer');
        this.dropdownHeight = this.dropdown.getHeight('outer');
        if (this.currentAlignment.startsWith('T')) {
            this.dropdown.classList.add('dr-dropdown_top');
        }
        else {
            this.dropdown.classList.remove('dr-dropdown_top');
        }
    }
}
exports.default = Dropdown;
__decorate([
    Bind_1.default
], Dropdown.prototype, "show", null);
__decorate([
    Bind_1.default
], Dropdown.prototype, "hide", null);
__decorate([
    Bind_1.default
], Dropdown.prototype, "toggle", null);
__decorate([
    (0, Debounce_1.default)(100, true)
], Dropdown.prototype, "reposition", null);
//# sourceMappingURL=Dropdown.js.map